import React, { useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import Collapse from '@mui/material/Collapse';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Typography } from '@mui/material';

function CurrentTime() {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    // Update the current time every second
    const intervalId = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    // Clean up the interval when the component unmounts
    return () => clearInterval(intervalId);
  }, []); // Empty dependency array means the effect runs only once, similar to componentDidMount

  return (
    <Typography>Current Time: {currentTime.toLocaleTimeString()}</Typography>
  );
}

const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
}));

export default function SessionInfo({ event_details }) {
  const [expanded, setExpanded] = useState(false);
  const handleExpandClick = () => {
    setExpanded(!expanded);
  };
  const currentSession = event_details.sessions[0].name;
  return (
    <Paper sx={{ mb: 1, mt: 1 }}>
      <Box
        sx={{
          bgcolor: 'background.paper',
          borderRadius: 1,
        }}
      >
        <Box
          sx={{
            height: 60,
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
          }}
          onClick={handleExpandClick}
        >
          <Box
            sx={{
              height: 60,
              width: '100%',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Box>
              <Typography ml={2}>
                {event_details?.event_name} - {currentSession}
              </Typography>
            </Box>
            <Box mr={2}>
              <CurrentTime />
            </Box>
          </Box>
          <ExpandMore
            expand={expanded}
            onClick={handleExpandClick}
            aria-expanded={expanded}
            aria-label="show more"
          >
            <ExpandMoreIcon />
          </ExpandMore>
        </Box>
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <Box
            sx={{
              height: '400px',
              width: '100%',
              minWidth: '100%',
            }}
          >
            {JSON.stringify(event_details)}
          </Box>
        </Collapse>
      </Box>
    </Paper>
  );
}
